import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import { PropsWithChildren, useEffect } from 'react';
import { isAppTheme, useThemeContext } from '@theme/ThemeContext';
import { useUser } from '@auth/AuthContext';
import { useTrackPageViews } from '@analytics/Analytics';
import Header from '@components/header';
import { useAppContext } from './AppContext';

export default function App({ children }: Readonly<PropsWithChildren<{}>>) {
  useTrackPageViews();
  const { platform, isLoading } = useAppContext();
  const { userTheme } = useUser();
  const { themeName, setTheme } = useThemeContext();

  const styles = useStyles();

  useEffect(() => {
    if (userTheme && isAppTheme(userTheme)) {
      setTheme(userTheme);
    }
  }, [userTheme, setTheme]);

  if (isLoading) {
    return null;
  }

  return (
    <div className={mergeClasses(styles.container, themeName)}>
      <div className={styles.content}>
        {platform === undefined ? <Header /> : null}
        {children}
      </div>
    </div>
  );
}

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    marginRight: tokens.spacingHorizontalXXXL,
    marginLeft: tokens.spacingHorizontalXL,
    alignContent: 'center',
    justifyContent: 'center',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '1120px',
    marginTop: tokens.spacingVerticalL,
    width: '100%',
    alignContent: 'center',
    justifyContent: 'center',
  },
});
